export default function ConfirCircleIcon(props) {
    return (
        <svg width={props.width || "66"} height={props.height || "66"} viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M63 30.2572V33.0172C62.9963 39.4864 60.9015 45.7812 57.028 50.9626C53.1545 56.1441 47.7098 59.9346 41.5061 61.7688C35.3023 63.6031 28.6718 63.3828 22.6034 61.1409C16.535 58.899 11.354 54.7555 7.83288 49.3284C4.3118 43.9013 2.63937 37.4813 3.06503 31.0261C3.49069 24.5709 5.99162 18.4261 10.1948 13.5084C14.3981 8.59063 20.0783 5.16332 26.3886 3.73761C32.6988 2.3119 39.3008 2.96418 45.21 5.59717M63 9L33 39.03L24 30.03" stroke="#1D8D3C" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}
